import { headerStyles } from "@insite/content-library/Widgets/RequestRma/RequestRmaHeader";
import { css } from "styled-components";

headerStyles.title = {
    variant: "h2",
    as: "h1",
    css: css`
        margin-bottom: 0;
    `,
};

headerStyles.buttonsGridItem = {
    css: css`
        justify-content: flex-end;
        align-items: flex-end;
    `,
    width: [2, 2, 2, 6, 6],
};

headerStyles.titleGridItem = {
    width: [10, 10, 10, 6, 6],
    css: css`
        align-items: flex-end;
    `,
};
